import { Button } from '../ui/Button';

export function FinalCTA() {
  return (
    <section id="create" className="final-cta">
      <div>
        <h2>Vytvoř si kalendář, který má smysl.</h2>
        <p>Tvůj rok. Tvé vzpomínky. Na zdi každý den.</p>
      </div>
      <Button href="/start">Vytvořit kalendář</Button>
    </section>
  );
}
